import { action } from 'satcheljs';
import { Folder } from 'owa-folders';

export const onAddSharedFolderSuccess = action(
    'ON_ADD_SHARED_FOLDER_SUCCESS',
    (sharedUserMailboxSmtpAddress: string, folder: Folder, userIdentity: string) => ({
        sharedUserMailboxSmtpAddress,
        folder,
        userIdentity,
    })
);
